import { render, staticRenderFns } from "./newsletter-section.vue?vue&type=template&id=f8b01ff8&scoped=true&"
import script from "./newsletter-section.vue?vue&type=script&lang=js&"
export * from "./newsletter-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b01ff8",
  null
  
)

export default component.exports